export const AM_UPDATE_STATE = "AM_UPDATE_STATE"
export const AM_UPDATE_AGENT_ACTIVE_CHATS_ITEM = "AM_UPDATE_AGENT_ACTIVE_CHATS_ITEM"
export const AM_MAKE_SOCKET_CONNECTION = "AM_MAKE_SOCKET_CONNECTION"
export const AM_CALL_SOCKET_METHOD = "AM_CALL_SOCKET_METHOD"
export const AM_SOCKET_DISCONNECT = "AGENT_MONITORING_SOCKET_DISCONNECT"
export const AM_EMIT_CUSTOM_EVENT = "AM_EMIT_CUSTOM_EVENT"
export const AM_UPDATE_AGENT_CHATS = "AM_UPDATE_AGENT_CHATS"
export const AM_CLOSE_CHAT_WINDOW = "AM_CLOSE_CHAT_WINDOW"
export const AM_UPDATE_AGENT_ACTIVE_CHATS_MESSAGE = "AM_UPDATE_AGENT_ACTIVE_CHATS_MESSAGE"